module.exports = __webpack_public_path__ + "static/media/menu-bottom.f07667ae.png";